import { Box } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const NavigationCategory = styled(Box) `
  padding-bottom: ${({ theme }) => theme.spacing[600]};
  break-inside: avoid;
`;
export const NavigationSubCategories = styled.ul `
  margin-top: ${({ theme }) => theme.spacing[100]};
  padding-left: 0;
  list-style-type: none;
  text-align: left;
`;
export const NavigationSubCategory = styled.li `
  margin-bottom: ${({ theme }) => theme.spacing[100]};
`;
//# sourceMappingURL=CategoryNavigation.styled.js.map